import { useEffect } from "react";
import { useSite } from "../../lib/site";

const SITE = "https://accessible.org.au";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ title, description, path = "/", image = "/images/og-image.jpg" }) {
  useEffect(() => {
    const full = `${title} | Accessible Trials & Mods`;
    document.title = full;
    setMeta("name", "description", description);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", SITE + path);
    setMeta("property", "og:image", image.startsWith("http") ? image : SITE + image);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = SITE + path;
  }, [title, description, path, image]);
  return null;
}

export function LocalBusinessSchema() {
  const { settings: s } = useSite();
  const data = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: s.business_name,
    url: SITE,
    email: s.public_email,
    image: `${SITE}/images/og-image.jpg`,
    description: "NDIS assistive technology trials that lead to purchase, and NDIS home modifications in Melbourne and Victoria.",
    areaServed: [{ "@type": "City", name: "Melbourne" }, { "@type": "State", name: "Victoria" }],
    address: { "@type": "PostalAddress", addressLocality: "Melbourne", addressRegion: "VIC", addressCountry: "AU" },
  };
  if (s.phone && /\d/.test(s.phone)) data.telephone = s.phone;
  if (s.address && !s.address.startsWith("[")) data.address.streetAddress = s.address;
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />;
}
